import React, {useState} from 'react';
import { Link } from 'react-router-dom';

function LoginMain({ onLoginSubmit }) {
    const [formData, setFormData] = useState({ email: '', password: '' });

    const handleSubmit = (e) => {
        e.preventDefault();
        const { email, password } = formData;
        onLoginSubmit({ email, password });
    };

    return (
        <main className="flex-1 flex flex-col items-center justify-center px-4 py-12 relative">
            <div className="absolute inset-0 z-0 opacity-10 pointer-events-none overflow-hidden">
                <img className="w-full h-full object-cover" alt="Abstract dark racing track with motion blur" src="https://lh3.googleusercontent.com/aida-public/AB6AXuBKqQz6UAyrrEQWu4miwbFSmBOAlwzRfW8LLitvVxaVavpDtcuSlJgt-iItw2dUTQ-BYp6frvs4tu9gDOpPaQAreXd6GJRA1iqmChzNW4UD6BJPqQ3O7SNvDKyt7hfWEQ8lrf1_zImFpC4VmbH_XHzSCl4ue-huzMhh0Gz34vH__A3cZ82mfq0uyAPfEEZ2JgDPqzz98o48HYWN4Rl2nXKP74ERx4YWVaMNSem4BNfOa2iKnNSfm2O7czVGrhjBFmEyFjdmUilj2Jo"/>
            </div>

            <div className="w-full max-w-[480px] z-10">
                <div className="text-center mb-8">
                    <h1 className="text-white tracking-tight text-[36px] font-bold leading-tight pb-2">Welcome Back</h1>
                    <p className="text-white/60 text-base font-normal leading-normal px-8">Inizialize your session to resume tracking.</p>
                </div>

                <div className="glass-card rounded-xl p-8 shadow-2xl">
                    <div className="p-0 flex flex-col mb-8 md:p-6 gap-5 text-center">
                        <p className="text-white/60 text-base font-normal leading-normal px-8">Login simply connecting your steam account</p>

                        <button className="w-full flex items-center justify-center gap-2 bg-[#171a21] hover:bg-[#2a475e] text-white py-3 px-4 rounded-lg transition-all font-medium border border-white/10 group">
                            <svg className="w-5 h-5 fill-current" viewBox={"0 0 24 24"} xmlns="http://www.w3.org/2000/svg">
                            <path d="M11.979 0C5.678 0 .513 4.881.012 11.054l6.505 2.682c.421-.305.938-.49 1.503-.49.191 0 .375.023.551.066l2.844-4.125V9.11c0-2.43 1.971-4.401 4.402-4.401s4.402 1.971 4.402 4.401-1.971 4.401-4.402 4.401c-.13 0-.258-.006-.385-.017l-3.924 5.704c.01.114.017.229.017.346 0 1.921-1.557 3.479-3.479 3.479s-3.479-1.558-3.479-3.479c0-.66.185-1.275.505-1.799l-6.28-2.589C1.196 20.378 6.062 24 11.979 24 18.6 24 24 18.627 24 12S18.6 0 11.979 0zM7.554 18.232c-1.104 0-2 .896-2 2s.896 2 2 2 2-.896 2-2-.896-2-2-2zm8.232-9.122c0 1.325-1.074 2.399-2.399 2.399s-2.399-1.074-2.399-2.399 1.074-2.399 2.399-2.399 2.399 1.074 2.399 2.399z"></path>
                        </svg>Connect with Steam</button>
                    </div>

                    <div className="relative flex items-center mb-8">
                        <div className="flex-grow border-t border-white/10"></div>
                        <span className="flex-shrink mx-4 text-white/30 text-xs uppercase tracking-widest">Or Register Manually</span>
                        <div className="flex-grow border-t border-white/10"></div>
                    </div>

                    <form className="space-y-5">
                        <div className="flex flex-col gap-2">
                            <label className="text-white/70 text-sm font-medium">Email Address</label>
                            <div className="relative">
                                <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-white/40 text-lg">mail</span>
                                <input onChange={e => setFormData({...formData, email: e.target.value})} className="input-glow w-full rounded-lg border border-[#324d67] bg-[#192633] text-white py-3 pl-12 pr-4 focus:outline-0 focus:ring-0 focus:border-primary transition-all placeholder:text-white/20" placeholder="driver@example.com" type="email"/>
                            </div>
                        </div>

                        <div className="flex flex-col gap-2">
                            <label className="text-white/70 text-sm font-medium">Password</label>
                            <div className="relative">
                                <span className="material-symbols-outlined absolute left-4 top-1/2 -translate-y-1/2 text-white/40 text-lg">lock</span>
                                <input onChange={e => setFormData({...formData, password: e.target.value})} className="input-glow w-full rounded-lg border border-[#324d67] bg-[#192633] text-white py-3 pl-12 pr-4 focus:outline-0 focus:ring-0 focus:border-primary transition-all placeholder:text-white/20" placeholder="••••••••" type="password"/>
                            </div>
                        </div>
                    </form>
                </div>

                <div className="pt-4">
                    <button onClick={handleSubmit} className="w-full bg-primary hover:bg-primary/80 text-white font-bold py-4 rounded-lg shadow-lg shadow-primary/20 transition-all flex items-center justify-center gap-2 group" type="submit">Enter Cockpit <span className="material-symbols-outlined">login</span></button>
                </div>
            </div>

            <div className="mt-8 text-center space-y-4">
                <p className="text-white/40 text-sm">New to the platform? <span className="text-primary hover:text-primary/80 font-semibold transition-colors"><Link to="/signup">Register your driver profile</Link></span></p>
                <p className="text-[10px] text-white/30 px-10">By registering, you agree to our <span className="underline">Terms of Service</span> and <span className="underline">Privacy Policy</span>. Telemetry data collection is subject to Assetto Corsa Competizione EULA.</p>
            </div>
        </main>
    );
}

export default LoginMain;